module.exports = __webpack_public_path__ + "static/img/bianji.png@2x.33eb6518.png";